// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"8def9c33","264":"c26b11d9","415":"fe89b401","533":"1026593e","538":"aeed7b96","706":"e14bbc19","891":"0f333812","974":"6c242183"}[chunkId] + ".chunk.css";
};